module.exports = __webpack_public_path__ + "img/home-1.fde0b1f2.webp";